"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SelectPharmacyModal = _interopRequireDefault(require("./SelectPharmacyModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _SelectPharmacyModal.default;
exports.default = _default;